import React, { useState, useContext } from 'react'
import { motion } from 'framer-motion'
/*COMPONENTS */
import Header from '../../components/Header'
import TableListCategorys from '../../components/TableListCategorys'
import SidebarEl from '../../components/SidebarEl'
import Filter from '../../components/Filter'
import styled from 'styled-components'
import ModalCategory from '../../components/ModalCategory'
import ModalEditCategory from '../../components/ModalEditCategory'
import MobileMenu from '../../components/MobileMenu'

import { CategorysContext } from '../../context/categorys'

import { ToastContainer, toast } from 'react-toastify';

const CardWrapper = styled.section`
    background-color: #fafafa;
    height: 100vh;
    display: flex;

   
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        display: flex;
        flex:1;
        padding: 1.7rem;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const CleanMobile = styled.div`

@media screen and (max-width:720px){
        height:120px
}
`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`

const Categorys = () => {

    const { animation, categorys, get, setShowModalEdit, showModalEdit } = useContext(CategorysContext)

    const [modalShow, setModalShow] = React.useState(false);

    const [structure] = useState([
        {
            name: "Id",
        },
        {
            name: "Nome",
        },
        {
            name: "Editar"
        },
        {
            name: "Excluir"
        },


    ])

    function MyVerticallyCenteredModal(props) {
        return (
            <ModalCategory props={props} />
        );
    }

    function EditModal(props) {
        return (
            <ModalEditCategory props={props} />
        );
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper>
                <div className='colum_primary'>
                    <SidebarEl />
                </div>
                <FixWidthSidebar/>
                
                <div className='colum_secondary'>
                    <Header name="Minhas Categorias" />
                    <Filter buttonName={"Adicionar"} type={1} onClick={() => setModalShow(true)} onChange={(e) => get(e.target.value)} animation={animation} />

                    <TableListCategorys structure={structure} data={categorys} animation={animation} />

                    <MyVerticallyCenteredModal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                    />

                    <EditModal
                        show={showModalEdit}
                        onHide={() => setShowModalEdit(false)}
                    />
                <CleanMobile />

                </div>

                <MobileMenu />

            </CardWrapper>

        </motion.div>

    )
}

export default Categorys